import type { Meta, StoryObj } from "@storybook/web-components";
import { ServiceReportsTemplate, ServiceReportsProps } from "./ServiceReports";

export default {
    title: "ServiceReports",
    component: "mf-service-reports",
    tags: ["autodocs"],
    render: (args) => ServiceReportsTemplate(args),
    argTypes: {
        locale: {
            control: { type: "select" },
            options: ["de-DE", "en-US"]
        },
        env: {
            control: { type: "select" },
            options: ["dev", "qa", "prod"]
        },
        legacyApi: {
            control: { type: "boolean" }
        },
        machineNumber: {
            control: { type: "text" }
        },
        missionNumber: {
            control: { type: "text" }
        },
        technicianName: {
            control: { type: "text" }
        },
        machineAlias: {
            control: { type: "text" }
        },
        machineName: {
            control: { type: "text" }
        },
        hideFilter: {
            control: { type: "boolean" }
        },
        hideNewReportTypes: {
            control: { type: "boolean" },
            table: {
                category: "Deprecated"
            }
        }
    }
} satisfies Meta<ServiceReportsProps>;

type Story = StoryObj<ServiceReportsProps>;

export const ServiceReportsForMachine: Story = {
    args: {
        locale: "de-DE",
        env: "qa",
        legacyApi: false,
        machineNumber: "900011",
        hideNewReportTypes: true
    }
};

export const ServiceReportsForMission: Story = {
    args: {
        locale: "en-US",
        env: "qa",
        legacyApi: false,
        missionNumber: "7850484",
        technicianName: "John Doe",
        machineAlias: "Mausepups",
        machineName: "Trulaser 3030",
        machineNumber: "900011",
        hideNewReportTypes: true
    }
};
